import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import WOW from "wowjs"; //https://codeburst.io/animate-your-react-in-2-mins-dd4b50c45976

import Aboutus from '../../page-blocks/single/aboutus';
import Contactus from '../../page-blocks/single/contactus';
import Services from '../../page-blocks/single/services';
import Expertise from '../../page-blocks/single/expertise';
import Team from '../../page-blocks/single/team';
import Portfolio from '../../page-blocks/single/portfolio';
import Products from '../../page-blocks/single/products';
import Testimonial from '../../page-blocks/single/testimonial';
import Intro from '../../page-blocks/single/intro';
import Whyus from '../../page-blocks/single/whyus';
import Clients from '../../page-blocks/single/clients';
import Footer from '../../page-blocks/common/footer';
import Header from '../../page-blocks/common/header';
import { Seo } from "../../utilities/Seo";

const Home = () => {





  // Scroll to section if URL contains a hash (e.g. navigating from Careers page)
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      // Wait for the page to fully render before scrolling
      const timer = setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) {
          const header = document.getElementById('header');
          const offset = header ? header.offsetHeight : 0;
          window.scroll({
            top: target.offsetTop - offset,
            behavior: 'smooth',
          });
        }
      }, 600);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const wowElements = document.querySelectorAll(".wow");
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animated");
              entry.target.style.visibility = "visible";
              entry.target.style.animationName = "";
              const duration = entry.target.getAttribute("data-wow-duration");
              const delay = entry.target.getAttribute("data-wow-delay");
              if (duration) entry.target.style.animationDuration = duration;
              if (delay) entry.target.style.animationDelay = delay;

              // Prevent resetting while the animation is actively executing
              entry.target.dataset.animating = "true";
              const durSec = parseFloat(duration || "1");
              const delSec = parseFloat(delay || "0");
              const totalMs = (durSec + delSec) * 1000 + 200;
              setTimeout(() => {
                if (entry.target) {
                  entry.target.dataset.animating = "false";
                }
              }, totalMs);
            } else {
              // Only reset if the entrance animation has finished playing
              if (entry.target.dataset.animating !== "true") {
                entry.target.classList.remove("animated");
                entry.target.style.visibility = "hidden";
                entry.target.style.animationName = "none";
              }
            }
          });
        },
        { 
          threshold: 0,
          rootMargin: "120px 0px 120px 0px"
        }
      );

      wowElements.forEach((el) => {
        el.style.visibility = "hidden";
        observer.observe(el);
      });
    }, 400);

    return () => clearTimeout(timer);
  }, []);


  return (
    <>
      <Seo />
      <body>
        <Header></Header>
        <Intro></Intro>
        <main id="main">
          <Products></Products>
          <Services></Services>
          <Expertise></Expertise>
          <Whyus></Whyus>
          <Team></Team>
          <Testimonial></Testimonial>
          <Portfolio></Portfolio>
          {/* Our Clients section — hidden but preserved */}
          <div style={{ display: "none" }} aria-hidden="true">
            <Clients></Clients>
          </div>
          <Aboutus></Aboutus>
          <Contactus></Contactus>
        </main>
        <Footer></Footer>

        <a href="#" className="back-to-top">
          <i className="fa fa-chevron-up"></i>
        </a>
        {/* Uncomment below i you want to use a preloader */}
        {/* <div id="preloader"></div> */}
      </body>
    </>
  );
};

export default Home;
